import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	conditions: {
		id: 'servicedesk-sla-settings.common.conditions.condition-title.conditions',
		defaultMessage: 'Conditions',
		description: 'header for conditions section',
	},
	timeCondition: {
		id: 'servicedesk-sla-settings.common.conditions.condition-title.time-condition',
		defaultMessage: 'Time will be measured between the start and stop conditions below.',
		description: 'information text for time start and time stop conditions ',
	},
});
